import { IJsonQuery } from '@cian/api-models/common/json_query';

import { FILTERS_SET_PRICE_TYPE } from '../../../constants/action_types';
import { TReduxActions } from '../../../types/redux';
import { JsonQuery } from '../../../utils/jsonQuery';

import { defaultState } from './defaultState';

export function setPriceTypeReducer(jsonQuery: IJsonQuery = defaultState, action: TReduxActions): IJsonQuery {
  switch (action.type) {
    case FILTERS_SET_PRICE_TYPE:
      return new JsonQuery(jsonQuery).setPriceType(action.payload).getSerializable();

    default:
      return jsonQuery;
  }
}
